module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseModal', {
    attrs: {
      "class-name": 'ListItemModal',
      "title": _vm.id ? _vm.name : 'LIST__NEW_ITEM'
    },
    on: {
      "save": _vm.save,
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "ListItemModal__body"
  }, [(_vm.id) ? _c('div', {
    staticClass: "ListItemModal__delete-container"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__DELETE',
      "class-name": 'ListItemModal__delete'
    },
    on: {
      "click": function($event) {
        _vm.confirmDeleteItem()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'LIST__NAME',
      "value": _vm.name,
      "errors": _vm.errors['name']
    },
    on: {
      "change": function($event) {
        _vm.setName($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseSegmented', {
    attrs: {
      "value": _vm.sex,
      "items": _vm.sexes
    },
    on: {
      "change": _vm.setSex
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33fbff08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/ListItemModal.vue
// module id = 574
// module chunks = 1